<ion-header>
  <ion-toolbar class="ion-text-center">
    <ion-title>Enter PIN</ion-title>

    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close(false)">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="form-container">
    <hub-pin-input #hubPinInput [maxPin]="REQUIRED_PIN_LENGTH" (changed)="pinChanged($event)"></hub-pin-input>
    <div #dummyContainer></div>
  </div>
</ion-content>
